import { Component, Prop } from 'vue-property-decorator';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';

import PaginationInterface from '@core/interfaces/pagination-interface';
import Vue from 'vue';
import { Payment } from '@accounting/interfaces/payment';
import moment from 'moment';

@Component({
  name: 'pos-checkout-payments-list',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
  },
})
export default class PosCheckoutPaymentsList extends Vue {
  $refs: {
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(): void;
      items: any[];
      fields: any[];
      queryConfig: any;
      loadingURLQueryParams: boolean;
      loadingTabURLQueryParams: boolean;
      withTabFilter: boolean;
      canLoadEntities: boolean;
      firstLoadEntities: boolean;
      initialFilters: Record<string, any>[];
      pagination: PaginationInterface;
    };
  };
  @Prop(Array) readonly value: any[];

  selectEntity: string = 'payment';
  selectPluralEntity: string = 'payments';

  @Prop(Array) readonly filters: any[];
  @Prop({ type: [Number, String] }) readonly ticketId: number | string;

  @Prop({
    type: Array,
    default: () => ['configLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  public entity: any = null;
  public entityName = this.selectEntity;
  public pluralEntityName = this.selectPluralEntity;
  public refreshingPayments: boolean = false;

  mounted() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].mounted(this);
    }
  }
  destroyed() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].destroy(this);
    }
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  async getEntities() {
    this.$refs.provider.getEntities();
  }

  async refreshPayments() {
    this.refreshingPayments = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('pos');
    const url = `${basePath}/payments/refresh-payments-in-ticket/${this.ticketId}`;
    await this.$bpcApi.post(url).toPromise();
    await this.getEntities();
    this.refreshingPayments = false;
  }

  get tableData(): any {
    const result = {
      fields: [
        // {
        //   key: 'code',
        //   label: this.$t('global.code.label'),
        // },
        {
          key: 'payment_date',
          label: this.$t('global.fields.date.label'),
        },
        {
          key: 'payment_method_type',
          label: this.$t('global.payment_method_type.label'),
        },
        {
          key: 'formatted_paid_amount',
          label: this.$t('global.paid_amount.header_label'),
        },
        {
          key: 'status',
          label: this.$t('global.status.label'),
        },
      ],
      items: [],
    };
    this.$refs.provider.items.forEach((payment: Payment) => {
      // TODO - Format price and date before to the push
      const newPayment = { ...payment };
      newPayment.payment_date = moment(String(payment.payment_date), 'YYYY-MM-DD').format('DD/MM');
      newPayment.payment_method_type = this.$t(payment.payment_method_type).toString();
      newPayment.formatted_paid_amount = this.formatAmount(payment.paid_amount);
      newPayment.status = this.$t('global.status.' + payment.status).toString();
      result.items.push(newPayment);
    });
    return result;
  }

  formatAmount(value: number) {
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  get payments(): Payment[] {
    return this.$refs.provider?.items;
  }

  onLoadItems() {
    this.$emit('on-load-items', this.payments);
  }
}
